<div class="w-full flex flex-col justify-center items-center mt-5">
  <div class="w-full flex items-center"> <h2 class="pt-3 text-white font-medium text-center w-full">Rating and
      Reviews</h2>
  </div>


  <!-- <div class="container flex flex-col justify-center items-center md:mt-5 gap-5 md:gap-10">
    <img src="../../../../../assets/images/cariq-app-v2.png" alt="" class="w-11/12 md:w-10/12">
    <div class="flex flex-wrap gap-5 md:gap-10 justify-center items-center flex-col md:flex-row w-full">
      <a href="https://play.google.com/store/apps/details?id=com.cariq.mobility.cariqdriven" target="_blank"
        rel="noopener noreferrer"> <img src="../../../assets/images/get-on-play-store-overlay.png" alt=""
          class="h-20 w-full"></a>
      <a href="https://apps.apple.com/in/app/cariq-driven/id1194939452" target="_blank" rel="noopener noreferrer">
        <img src="../../../assets/images/get-on-app-store-overlay.png" alt="" class="h-20 w-full">
      </a>
    </div>
  </div> -->


  <app-play-store-app-store-cta></app-play-store-app-store-cta>

</div>

<!-- Desktop Reviews Section with Background -->
<div class="relative w-full bg-cover bg-center bg-no-repeat hidden sm:block">
  <!-- Overlay for better text readability -->
  <!-- <div class="absolute inset-0 bg-black bg-opacity-40"></div> -->

  <!-- Content Container -->
  <div class="relative z-10 container mx-auto py-8 md:py-16">
    <!-- Heading -->
    <div class="flex items-center justify-center mb-8">
      <span class="font-bold text-4xl  text-store-dark ">What customers say</span>
    </div>

    <!-- Desktop Reviews Carousel -->
    <div class="relative flex justify-center">
      <div class="flex overflow-hidden space-x-4 w-11/12" #testimonialContainer>
        <div *ngFor="let review of reviews"
          class="w-2/6 flex-shrink-0 py-8 px-5 bg-white/10 backdrop-blur-sm rounded-lg border border-white/20">
          <span class="text-yellow-500">{{
            review.stars }}</span>
          <p class="font-bold">{{review.subReview}}</p>


          <p class="text-xs md:text-sm mt-4 text-gray-400 italic">{{ review.review }}</p>
          <div class="flex gap-3 justify-between mt-5">
            <div class="flex gap-3">
              <div class="h-12 w-12 rounded-full">
                <img src="../../../../../assets/images/storev2/review-avatar.png" alt="">
              </div>
              <div class="flex flex-col">
                <div class="text-md text-sm font-semibold text-white">{{ review.name }}</div>
                <span class="text-gray-400 text-sm">Happy Client</span>
              </div>
            </div>
            <div>
              <img src="../../../.././../assets/images/storev2/rating-quotes.png" alt="" class="h-4">
            </div>
          </div>
        </div>
      </div>
      <div class=" absolute mt-2 top-full right-24 flex gap-3">
        <button (click)="scrollLeft()"
          class="h-10 w-10 bg-white/10 border border-white/20 hover:bg-white/20 rounded-full p-2 focus:outline-none">
          <i class='bx bx-chevron-left' style="font-size: 25px; color: white;"></i>
        </button>
        <button (click)="scrollRight()"
          class="h-10 w-10 bg-white/10 border border-white/20 hover:bg-white/20 rounded-full p-2 focus:outline-none">
          <i class='bx bx-chevron-right' style="font-size: 25px; color: white;"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Mobile Reviews Section -->
<div class="container mx-auto py-2 md:py-10 mt-5 sm:hidden">
  <div class="flex items-center justify-center mt-5">
    <span class="font-bold text-2xl md:text-3xl">What customers say</span>
  </div>

  <!-- Mobile Reviews List -->
  <div class="relative flex flex-col justify-center mt-8 gap-5">
    <!-- Always visible reviews (first 3) -->
    <div *ngFor="let review of visibleReviews" class="w-full py-14 px-5 bg-white/5 border border-white/10 rounded-lg">
      <div class="text-md md:text-lg font-semibold">{{ review.name }}</div>
      <span class="text-yellow-500">{{ review.stars
        }}</span>
      <p class="text-xs md:text-sm mt-4 text-gray-300">{{ review.review }}</p>
    </div>
  </div>
</div>

<span (click)="toggleShowMore()"
  class="sm:hidden mt-4 mb-4 ms-5 b text-gray-500 text-sm hover:underline cursor-pointer">
  {{ showMore ? 'Show Less' : 'Show More' }}
</span>